import { Container, LabelWrapper } from './LegendRadioItemStyles';
import RadioButton from '@/ui/buttons/radioButton/RadioButton';

interface LegendRadioItemProps {
  children: React.ReactNode;
  onClick: () => void;
  name: string;
  isSelected: boolean;
  isDisabled?: boolean;
}

const LegendRadioItem = ({
  children,
  onClick,
  name,
  isSelected = false,
  isDisabled = false,
}: LegendRadioItemProps) => {
  return (
    <Container onClick={onClick}>
      <LabelWrapper>{children}</LabelWrapper>
      <RadioButton isChecked={isSelected} name={name} onChange={() => {}} />
    </Container>
  );
};

export default LegendRadioItem;
